import { format } from 'date-fns';
import { FC, useMemo, useState } from 'react';

import Loader from 'components/Loader';
import { CorrespondenceDirectionType, CorrespondenceForm, CorrespondenceStatusType } from 'types/correspondence';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { DEFAULT_DATE_FORMAT } from 'utils/parseDate';
import { useClassifiers } from 'utils/useClassifiers';
import CorrespondencePageForm from './CorrespondencePageForm';

const USED_CLASSIFIERS = [
    'CORRESPONDENCE_DIRECTION',
    'CORRESPONDENCE_TYPE',
    'CORRESPONDENCE_STATUS_TYPE',
    'CORRESPONDENCE_CATEGORY_TYPE',
];

const CorrespondencePageAdd: FC = () => {
    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({
        codes: USED_CLASSIFIERS,
    });
    const [now] = useState(() => Date.now());

    const initialData = useMemo<CorrespondenceForm | undefined>(() => {
        if (!classifiers) {
            return undefined;
        }
        return {
            readOnlyNumber: '',
            name: '',
            typeCode: null,
            directionTypeCode: CorrespondenceDirectionType.INCOMING,
            categoryTypeCode: null,
            date: format(now, DEFAULT_DATE_FORMAT),
            documentDate: format(now, DEFAULT_DATE_FORMAT),
            isOfficial: false,
            officialReference: '',
            employees: [],
            sendersOrRecipients: [],
            note: '',
            isHandled: false,
            statusTypeCode:
                getValidOptionsFromClassifier<string, string>(classifiers['CORRESPONDENCE_STATUS_TYPE']).find(
                    (item) => item.value === CorrespondenceStatusType.IN_PROGRESS
                ) ?? null,
            clients: [],
            matters: [],
            assignments: [],
            dmsLink: '',
        };
    }, [classifiers, now]);

    if (isLoadingClassifiers || initialData === undefined) {
        return <Loader />;
    }

    return <CorrespondencePageForm type="add" initialData={initialData} classifiers={classifiers} />;
};

export default CorrespondencePageAdd;
